import { EOLocale } from 'eo-locale';
import React from 'react';
import Image from '@react/shared/Image';
const CaseStudyCard = ({ title, image, url, content, authorName, award, }) => (React.createElement("div", { className: "grid-column" },
    React.createElement("a", { href: url, className: "card card-uni", "data-aos": "animated" },
        React.createElement("div", { className: "card-uni__media" },
            React.createElement("div", { className: "card-uni__media-holder" },
                React.createElement(Image, { image: image, alt: title, ratio: 1, width: 460, className: "card-uni__media-element", cdn: true }))),
        React.createElement("div", { className: "card-uni__tag" },
            React.createElement("div", { className: "tag tag--dark-blue" },
                React.createElement(EOLocale.Text, { id: "xperience.pintext.casestudy" }))),
        React.createElement("div", { className: "card-uni__content" },
            award && (React.createElement("div", { className: "card-uni__award" },
                React.createElement("div", { className: "card-uni__icon-content" },
                    React.createElement("div", { className: "kentico-circle-icon kentico-circle-icon--white" },
                        React.createElement("div", { className: "icon-circle" },
                            React.createElement("svg", { className: "icon-svg", viewBox: "0 0 24 24" },
                                React.createElement("use", { xlinkHref: "/src/img/svg/icon-trophy-2.svg#icon-trophy-2" })))),
                    React.createElement("span", { className: "card-uni__icon-content-title" }, award)))),
            React.createElement("h3", { className: "card-uni__title" }, title),
            React.createElement("p", { className: "card-uni__intro" }, content),
            authorName && (React.createElement("div", { className: "card-uni__content-bottom" },
                React.createElement("div", { className: "card-uni__author" },
                    React.createElement(EOLocale.Text, { id: "xperience.deliveredby" }),
                    ": ",
                    authorName)))))));
export default CaseStudyCard;
